import { SizeProps } from "modules/products/types";

const getSizeSale = (
  size: SizeProps
): (SizeProps & { salePrice: number }) | undefined => {
  const { price, sales } = size;

  if (sales.length === 0) return;

  const { valueType, value } = sales[0];

  if (valueType === "value") return { ...size, salePrice: price - value };
  return { ...size, salePrice: price - price * (value / 100) };
};

export default getSizeSale;
